/**
 * Shifts and cash zod schemas (docs/SPEC.md §6).
 */
import { z } from 'zod';
import { idSchema, paisaSchema, positivePaisaSchema } from './common.js';
export const openShiftSchema = z.object({
    shopId: idSchema,
    registerId: idSchema.optional(),
    /** Opening cash — a shift may legitimately start from an empty drawer (0 is valid). */
    openingFloatPaisa: paisaSchema.min(0).default(0),
    note: z.string().max(300).optional(),
});
/** The only kinds a human posts directly — everything else is system-written. */
export const MANUAL_CASH_MOVEMENT_KINDS = ['PAY_IN', 'PAY_OUT', 'DROP_TO_SAFE', 'BANK_DEPOSIT', 'ADJUSTMENT'];
export const postCashMovementSchema = z.object({
    kind: z.enum(MANUAL_CASH_MOVEMENT_KINDS),
    /** Always a positive magnitude — the service applies the correct sign for the kind. */
    amountPaisa: positivePaisaSchema,
    reason: z.string().max(300).optional(),
});
export const closeShiftSchema = z.object({
    countedCashPaisa: paisaSchema.min(0),
    denominations: z.record(z.string(), z.number().int().min(0)).optional(),
    note: z.string().max(500).optional(),
});
/**
 * Day close (docs/BUILD-PHASES.md Phase 6 item 1 — `DayClose`, the day-level
 * aggregate above a shift). Closing a day is independent of closing any one
 * shift — a multi-till shop can have every shift closed and still need one
 * person to close the day as a whole, or vice versa.
 */
export const closeDaySchema = z.object({
    shopId: idSchema,
    /** Defaults to today (UTC date) — a business normally closes today, not an arbitrary date. */
    businessDate: z.coerce.date().optional(),
    countedCashPaisa: paisaSchema.min(0).optional(),
    note: z.string().max(500).optional(),
});
export const listShiftsQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
    shopId: idSchema.optional(),
    status: z.string().optional(),
});
//# sourceMappingURL=shifts.js.map